var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 6,
    viewBox: "0 0 101 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000325441 2.66699C0.000325313 4.13975 1.19423 5.33366 2.66699 5.33366C4.13975 5.33366 5.33366 4.13975 5.33366 2.66699C5.33366 1.19423 4.13975 0.00032557 2.66699 0.000325441C1.19423 0.000325313 0.00032557 1.19423 0.000325441 2.66699ZM2.66699 2.66699L2.66699 3.16699L100.667 3.167L100.667 2.667L100.667 2.167L2.66699 2.16699L2.66699 2.66699Z",
    fill: "#C1D9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.52c827b8a8515ca552274a3af3726da5.svg";
export { ForwardRef as ReactComponent };